import React from "react";
import CsI18n from "../../shared/csI18n";
import {
  Page,
  Layout,
  Card,
  FormLayout,
} from '@shopify/polaris';
import Switch from "react-switch";
import "../../styles/mycompany.scss";
import MyCompanyRequest from "../../requests/MyCompanyRequest";
import ChoiceHelper from "../../helpers/ChoiceHelper";
import { CsValidationForm } from "../../shared/csValidationForm";
import LegalAppBridge from "../../LegalAppBridge";
import HeadingHelper from "../../helpers/HeadingHelper";
import CompanyPayment from "./CompanyPayment";
import CompanyDetails from "./CompanyDetails";
import CompanyLocation from "./CompanyLocation";
import CompanyMarketplaces from "./CompanyMarketplaces";
import CompanyCustomerService from "./CompanyCustomerService";
import CompanyLegalInfo from "./CompanyLegalInfo";
import CompanySkeleton from "./CompanySkeleton";
import CSPageActions from "../CSPageActions";
import CompanyMediation from "./CompanyMediation";

export default class MyCompany extends React.Component {
  validatorClassDetails = 'details';
  validatorClassLocation = 'location';
  validatorClassLegalInfo = 'legalInfo';
  validatorClassCustomerService = 'customerService';
  validatorClassMediation = 'mediation';

  savedState = {};
  untrackState = ['init', 'saving', 'validateError', 'phoneError'];
  unSaveState = this.untrackState;

  state = {
    init: true,
    saving: false,
    validateError: false,
    //Details
    websiteName: '',
    companyName: '',
    domainName: '',
    chiefGender: '',
    chiefFirstName: '',
    chiefLastName: '',
    pubDirectorGender: '',
    pubDirectorFirstName: '',
    pubDirectorLastName: '',
    registrationState: '',
    registrationCountry: '',
    companyRegistrationID: '',
    regulatedActivity: false,
    companyType: [],
    companyTypeOther: '',
    capital: '',
    currency: 'USD',
    registrationDate: '',
    //Location
    address1: '',
    address2: '',
    theState: '',
    postCode: '',
    city: '',
    country: '',
    phone: '',
    phoneError: '',
    phoneCountryCode: undefined,
    fax: '',
    email: '',
    //Legal information
    hasVatNumber: false,
    vatNumber: '',
    hasDunsNumber: false,
    dunsNumber: '',
    physicalStore: false,
    subcontractedCarriers: false,
    // Remove files and agreementTrustedSeller + agreementToShare
    //Payment methods
    paymentGatewaysActive: false,
    paymentGateways: [],
    paymentGatewayOthers: '',
    cardTypesActive: false,
    cardTypes: [],
    // Removed bank gateways
    voucherDiscount: false,
    //Shipping methods are moved to their own page
    //Marketplaces
    marketplaceActive: false,
    marketplaces: [],
    marketplaceOthers: '',
    B2B: false,
    B2C: false,
    // Customer service
    customerServiceActive: false,
    workingDays: [],
    workingTimeStart: '',
    workingTimeEnd: '',
    afterSaleEmail: '',
    afterSalePhone: '',
    responseDuration: '',
    responseDurationUnit: [],
    afterSaleWebPage: '',
    // Mediation
    mediationServiceName: '',
    mediationUrl: '',
  }

  discardChanges = () => {
    this.setState(this.props.getSavedState(this.savedState, this.untrackState));
  }

  componentDidMount() {
    this.handleLoad();
  }

  handleLoad = () => {
    MyCompanyRequest.loadMyCompanySettingsR()
      .then(response => {
        if (response.success) {
          this.setState(response.data);
          this.savedState = this.props.getStateToBeSaved(this.state, this.untrackState);
        } else {
          LegalAppBridge.toastError(response.reason);
        }
      })
      .catch(Request.catchError)
      .finally(() => this.setState({ init: false }));
  }

  handleSave = () => {
    let validation = true;
    let validators = [
      this.validatorClassDetails, this.validatorClassLocation, this.validatorClassLegalInfo,
      this.validatorClassCustomerService, this.validatorClassMediation,
    ];
    validators.map(validatorClass => validation = validation && CsValidationForm.validate(validatorClass));

    if (!validation) {
      this.setState({ validateError: true });
    } else {
      this.setState({ saving: true });
      // Validate phone number in backend
      MyCompanyRequest.validatePhone({ phone: this.state.phone, country: this.state.country })
        .then(res => {
          if (res.hasOwnProperty('success') && res.success && res.hasOwnProperty('data') && res.data
            && res.data.hasOwnProperty('country_code') && res.data.hasOwnProperty('phone_formatted')) {
            const updatedState = {
              validateError: false,
              phoneError: '',
              phoneCountryCode: res.data['country_code'],
              phone: res.data['phone_formatted'],
            }
            this.setState(updatedState);

            // setState is async, we merge manually to make sure states is up to date when save
            let companyData = Object.assign({}, this.state, updatedState);
            this.unSaveState.map(key => delete companyData[key]);

            return MyCompanyRequest.saveMyCompanySettings(companyData);
          } else {
            this.setState({ validateError: true });
            const example = res?.example;
            let reason = res?.reason;
            if (reason) {
              reason = CsI18n.t(reason);
              if (example) {
                reason = `${reason} ${CsI18n.t('Example: {{phone}}', { phone: example })}`;
              }
              this.setState({ phoneError: reason });
              return Promise.reject(res.reason);  // Prevent double translation
            }
          }
        })
        .then(response => {
          if (response['success']) {
            LegalAppBridge.toast('Settings saved successfully');
            this.savedState = this.props.getStateToBeSaved(this.state, this.untrackState);
          } else {
            LegalAppBridge.toastError(response['reason']);
          }
        })
        .catch(error => {
          const toastError = error ? error : 'Unknown error';
          LegalAppBridge.toastError(toastError);
        })
        .finally(() => this.setState({ saving: false }));
    }
  }

  handleChange = name => event => {
    let stateToUpdate = { [name]: event.target ? event.target.value : event };
    // Clear server side validation error of phone when changed
    if (name === 'phone') {
      stateToUpdate['phoneError'] = '';
    }
    this.setState(stateToUpdate);
  }

  handleChoiceListChange = name => event => {
    const changedValue = event.target ? event.target.value : event;
    this.setState({ [name]: ChoiceHelper.onChange(changedValue, this.state[name]) });
  }

  // Not used at this time
  handleChoiceListChangeWithController = (choiceListName, control) => event => {
    const changedValue = event.target ? event.target.value : event;
    let changedState = { [choiceListName]: ChoiceHelper.onChange(changedValue, this.state[choiceListName]) };
    if (changedValue.length === 0) {
      changedState[control] = false;
    } else if (changedValue.length === (this.state[choiceListName]).length) {
      changedState[control] = true;
    }
    this.setState(changedState);
  }
  handleChoiceListAll = (control, target) => event => {
    const controlValue = event.target ? event.target.checked : event;
    this.setState({
      [control]: controlValue,
      [target]: ChoiceHelper.toggleAll(this.state[target], controlValue)
    });
  }
  // End: Not used at this time

  handleSelectChange = name => event => {
    const changedValue = event.target ? event.target.value : event;
    this.setState({ [name]: ChoiceHelper.onChange([changedValue], this.state[name]) });
  }

  // Remove handleDropZoneDrop, uploadedFiles, handleDeleteFile

  render() {
    const state = this.state;

    if (state.init) {
      return <CompanySkeleton />
    }

    return (
      <Page fullwidth>
        <Layout>
          <CompanyDetails
            websiteName={state.websiteName} companyName={state.companyName} domainName={state.domainName}
            chiefGender={state.chiefGender} chiefFirstName={state.chiefFirstName} chiefLastName={state.chiefLastName}
            pubDirectorGender={state.pubDirectorGender} pubDirectorFirstName={state.pubDirectorFirstName}
            pubDirectorLastName={state.pubDirectorLastName}
            registrationState={state.registrationState} registrationCountry={state.registrationCountry}
            companyRegistrationID={state.companyRegistrationID}
            regulatedActivity={state.regulatedActivity}
            companyType={state.companyType} companyTypeOther={state.companyTypeOther}
            capital={state.capital} currency={state.currency}
            registrationDate={state.registrationDate}
            handleChange={this.handleChange}
            handleSelectChange={this.handleSelectChange}
            validatorClass={this.validatorClassDetails}
          />

          <CompanyLegalInfo
            hasVatNumber={state.hasVatNumber} vatNumber={state.vatNumber}
            hasDunsNumber={state.hasDunsNumber} dunsNumber={state.dunsNumber}
            physicalStore={state.physicalStore} subcontractedCarriers={state.subcontractedCarriers}
            handleChange={this.handleChange}
            validatorClass={this.validatorClassLegalInfo}
          />

          <CompanyLocation
            address1={state.address1} address2={state.address2}
            theState={state.theState} postCode={state.postCode}
            city={state.city} country={state.country}
            phone={state.phone} phoneError={state.phoneError} fax={state.fax} email={state.email}
            handleChange={this.handleChange}
            validatorClass={this.validatorClassLocation}
          />

          <CompanyPayment
            paymentGatewaysActive={state.paymentGatewaysActive}
            paymentGateways={state.paymentGateways} paymentGatewayOthers={state.paymentGatewayOthers}
            cardTypesActive={state.cardTypesActive} cardTypes={state.cardTypes}
            voucherDiscount={state.voucherDiscount}
            handleChange={this.handleChange} handleChoiceListChange={this.handleChoiceListChange}
          />

          <CompanyMarketplaces
            marketplaceActive={state.marketplaceActive}
            marketplaces={state.marketplaces} marketplaceOthers={state.marketplaceOthers}
            handleChange={this.handleChange} handleChoiceListChange={this.handleChoiceListChange}
          />

          <CompanyCommercialModels
            B2B={state.B2B} B2C={state.B2C}
            handleChange={this.handleChange}
          />

          <CompanyCustomerService
            customerServiceActive={state.customerServiceActive}
            workingDays={state.workingDays}
            workingTimeStart={state.workingTimeStart} workingTimeEnd={state.workingTimeEnd}
            afterSaleEmail={state.afterSaleEmail} afterSalePhone={state.afterSalePhone}
            responseDuration={state.responseDuration} responseDurationUnit={state.responseDurationUnit}
            afterSaleWebPage={state.afterSaleWebPage}
            handleChoiceListChange={this.handleChoiceListChange} handleChange={this.handleChange}
            validatorClass={this.validatorClassCustomerService}
          />

          <CompanyMediation validatorClass={this.validatorClassMediation}
                            mediationServiceName={state.mediationServiceName} mediationUrl={state.mediationUrl}
                            handleChange={this.handleChange} />
        </Layout>

        <CSPageActions
          validateError={state.validateError} saving={state.saving}
          showSaveBar={Object.keys(this.savedState).length && !this.props.shallowCompareEqual(this.savedState, state, this.untrackState)}
          handleSave={this.handleSave} discardChanges={this.discardChanges} handleLoad={this.handleLoad}
        />
      </Page>
    )
  }
}

const CompanyCommercialModels = (props) => {
  const {
    handleChange,
    B2B, B2C,
  } = props;

  return (
    <Layout.AnnotatedSection description={CsI18n.t("company.annotate.desc.transaction_models")}>
      <Card>
        <Card.Section>
          <FormLayout>
            <FormLayout.Group>
              <div>
                <p>{HeadingHelper.ltt('B2B', 'company.explain.B2B')}</p>
                <Switch
                  className="react-switch"
                  onChange={handleChange('B2B')}
                  checked={B2B}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  aria-label={CsI18n.t("B2B")}
                />
              </div>
              <div>
                <p>{HeadingHelper.ltt('B2C', 'company.explain.B2C')}</p>
                <Switch
                  className="react-switch"
                  onChange={handleChange('B2C')}
                  checked={B2C}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  aria-label={CsI18n.t("B2C")}
                />
              </div>
            </FormLayout.Group>
          </FormLayout>
        </Card.Section>
      </Card>
    </Layout.AnnotatedSection>
  )
}
